/** Sesion movil: mismos endpoints que la web, UI propia (design.md §22.2). */
import { mobileApiClient, newIdempotencyKey } from './mobileApiClient';

export type MobileUser = {
  id: string;
  email: string;
  full_name: string;
  active_tenant_id: string | null;
  permissions: string[];
  memberships: { membership_id: string; tenant_id: string; tenant_name: string }[];
  /** URL relativa al logo del tenant activo (GET PNG). Null si no tiene logo. */
  tenant_logo_url: string | null;
  tenant_logo_alt_text: string | null;
};

export type Membership = {
  membership_id: string;
  tenant_id: string;
  tenant_name: string;
  status: string;
};

export type ChangePasswordBody = {
  current_password: string;
  new_password: string;
};

export type SuccessResponse = {
  message?: string;
};

export const authService = {
  async changePassword(body: ChangePasswordBody): Promise<SuccessResponse> {
    const { data } = await mobileApiClient.post('/api/v1/auth/change-password', body, {
      headers: { 'Idempotency-Key': newIdempotencyKey() },
    });
    return data as SuccessResponse;
  },
  async login(email: string, password: string): Promise<MobileUser> {
    const { data } = await mobileApiClient.post('/api/v1/auth/login', { email, password });
    return data.user as MobileUser;
  },
  async me(): Promise<MobileUser> {
    const { data } = await mobileApiClient.get('/api/v1/auth/me');
    return data as MobileUser;
  },
  async memberships(): Promise<Membership[]> {
    const { data } = await mobileApiClient.get('/api/v1/auth/memberships');
    return data as Membership[];
  },
  async switchContext(tenantId: string): Promise<MobileUser> {
    const { data } = await mobileApiClient.post('/api/v1/auth/context/switch', {
      tenant_id: tenantId,
    });
    return data.user as MobileUser;
  },
  async logout(): Promise<void> {
    await mobileApiClient.post('/api/v1/auth/logout');
  },
  async forgotPassword(email: string): Promise<void> {
    await mobileApiClient.post('/api/v1/auth/forgot-password', { email });
  },
};
